var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-body"},[_c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"allowfullscreen":"","src":'https://app.rentalios.com/rentalreport?noHeader=true'}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }